import { FileText } from "lucide-react";

export default function LogoHeader() {
  return (
    <div className="flex items-center space-x-3 min-w-0">
      <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center shrink-0">
        <FileText className="h-5 w-5 text-white" />
      </div>
      <div className="min-w-0">
        <h1 className="text-lg sm:text-xl font-bold text-gray-900 truncate">
          FitMyResume
          {/* <span className="text-red-600 text-sm"> dev</span> */}
        </h1>
        <p className="text-xs text-gray-500 hidden sm:block">
          Job Tailored Resumes
        </p>
      </div>
    </div>
  );
}
